import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import Transportista from './Transportista'
import ACCESS from '../../../ACCESS.js';

class Transportistas extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'transportista/filter', deleteUrl: 'transportista/delete', deleteField: 'nombre', modUrl: '/Catalogo/Transportista' },
      TableOp.Table('Transportistas', [
        { label: 'Clave', id: 'transportista' },
        { label: 'Nombre', id: 'transportista_nombre' },
      ], [
        { id: 'edit', icon: 'edit', access: [ACCESS.CATALOGO_TRANSPORTISTAS.EDITAR_CATALOGO] },
        { id: 'delete', icon: 'delete', access: [ACCESS.CATALOGO_TRANSPORTISTAS.ELIMINAR_CATALOGO] },
      ]))
    this.table();
  }

  render() {

    return (
      <div>
        <div>
          {
             
          <Transportista  onSave={() => {this.table()}}></Transportista>
        }
        {
           
          <this.TableRender  />
        }
        </div>
      </div>
    )
  }
}

export default withRouter(Transportistas)